import StateObserver from 'src/StateObserver';
import PopupCheats, { Item } from 'src/game/cheats/PopupCheats';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { CheatData } from 'src/game/cheats/cheats.sequences';
import { closeAllPopups } from 'src/lib/popups/popupOpenClose';
import { StreakBattleRoyaleStatus } from 'src/replicant/streakbattleroyale/streakbattleroyale.ruleset';
import { getStreakBattleRoyaleGoal } from 'src/replicant/streakbattleroyale/streakbattleroyale.getters';

const MATCH2_STREAK_EVENT_RESET = 'Reset Streak Event';
const MATCH2_STREAK_EVENT_PROGRESS = 'Streak Event Progress';
const MATCH2_STREAK_EVENT_STATUS = 'Streak Event Status';

const setStatus = async (data: CheatData) => {
  const status = data.type as StreakBattleRoyaleStatus;
  await StateObserver.invoke.cheat_streakBattleRoyaleSetStatus(status);
  closeAllPopups();
};

const setMilestone = async (data: CheatData) => {
  const amount = data.amount!;
  await StateObserver.invoke.cheat_streakBattleRoyaleProgress(amount);
  closeAllPopups();
};

const resetState = async (data: CheatData) => {
  const hardReset = data.amount! !== 0;
  await StateObserver.invoke.cheat_streakBattleRoyaleReset(hardReset);
  if (hardReset) window.location.reload();
  else closeAllPopups();
};

const list = () => {
  const user = StateObserver.getState().user;
  const cheats: Record<string, CheatData[]> = {};

  cheats[MATCH2_STREAK_EVENT_RESET] = ['Soft Reset', 'Hard Reset'].map(
    (label, i) => ({
      cheat: resetState,
      localeText: () => label,
      amount: i,
    }),
  );

  const goal = getStreakBattleRoyaleGoal(user);
  cheats[MATCH2_STREAK_EVENT_PROGRESS] = new Array(goal + 1)
    .fill(0)
    .map((_, i) => ({
      cheat: setMilestone,
      localeText: () => `Set to ${i}`,
      amount: i,
    }));

  const statuses: StreakBattleRoyaleStatus[] = [
    'available',
    'active',
    'failed',
    'expired',
    'completed',
    'rewarded',
  ];

  cheats[MATCH2_STREAK_EVENT_STATUS] = statuses.map((status) => ({
    cheat: setStatus,
    localeText: () => status,
    type: status,
  }));

  return cheats;
};

const ui = (args: {
  key: string;
  popup: PopupCheats;
  item: Item;
  title: LangBitmapFontTextView;
  setting: CheatData[];
  parent: Item | null;
}) => {
  const user = StateObserver.getState().user;

  switch (args.key) {
    case MATCH2_STREAK_EVENT_RESET:
    case MATCH2_STREAK_EVENT_PROGRESS:
    case MATCH2_STREAK_EVENT_STATUS: {
      args.item.dropdown = args.popup['createDropdown'](
        args.item,
        args.setting,
      );

      const viewToExtend = args.parent ?? args.item;

      let originalHeight: number = viewToExtend.style.height;
      args.item.dropdown.onOpen = () => {
        viewToExtend.updateOpts({
          zIndex: 1,
          height:
            originalHeight +
            args.item.dropdown.items.length * args.item.dropdown.itemHeight,
        });
      };
      args.item.dropdown.onClose = () => {
        viewToExtend.updateOpts({ zIndex: 0, height: originalHeight });
      };

      args.popup['createApplyButton'](args.item);

      break;
    }
  }
};

export const match2StreakBattleRoyaleCheats = {
  list,
  ui,
};
